<script setup lang="ts">
import { useGalleryStore } from "@/store/gallery.store";
import { onMounted, ref } from "vue";
import { useAuthStore } from "@/store/useAuthStore";
import { useAccountStore } from "@/store/account.store";
import Preloader from "@/components/Preloader.vue";
import { useRoute } from "vue-router";
const route = useRoute();

const authStore = useAuthStore();
const galleryStore = useGalleryStore();
const accountStore = useAccountStore();
const loading = ref(false);
const showContextMenu = ref(import.meta.env.VITE_DISABLE_INSPECT);

async function init() {
    loading.value = true;
    const response = await authStore.fetchUser();

    if (response) {
        galleryStore.dispatchGetGalleryImages();
        accountStore.dispatchGetAgencyProfile();
    }
    loading.value = false;
}

onMounted(() => {
    if(route.name!='NotFound'){
        init();
    }    
    if (showContextMenu.value == "true") {
        document.addEventListener("contextmenu", function (event) {
            event.preventDefault();
        });

        // Disable F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
        document.addEventListener("keydown", function (event) {
            if (
                event.key === "F12" ||
                (event.ctrlKey &&
                    event.shiftKey &&
                    (event.key === "I" ||
                        event.key === "J" ||
                        event.key === "C")) ||
                (event.ctrlKey && event.key === "U")
            ) {
                event.preventDefault();
            }
        });
    }
});
</script>

<template>
    <router-view v-if="!loading" />
    <Preloader v-else />
</template>
<style lang="scss" scoped>
.fade-enter-active,
.face-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    @apply opacity-0;
}
</style>
